<script>
import SubscriptionsSimpleTable from "@/components/packet/subscription/SubscriptionsSimpleTable.vue";
import ConfigInstruction from "@/components/account/ConfigInstruction.vue";
import PacketListExtended from "@/components/packet/PacketListExtended.vue";
import UserPacketsList from "@/components/packet/UserPacketsList.vue";
import UserPriceList from "@/components/packet/UserPriceList.vue";
import Playlists from "@/components/iptv/Playlists.vue";
import SubscriptionWidgetMixin from "@/components/packet/subscription/SubscriptionWidgetMixin";
import PlaylistEditor from "@/components/iptv/editor/PlaylistEditor.vue";
import PlaylistEditorDialog from "@/components/iptv/editor/PlaylistEditorDialog.vue";

export default {
  name: "IptvSubscriptionsWidget",
  mixins: [SubscriptionWidgetMixin],
  components: {
    PlaylistEditorDialog,
    PlaylistEditor,
    Playlists,
    UserPriceList,
    UserPacketsList,
    PacketListExtended,
    ConfigInstruction,
    SubscriptionsSimpleTable
  },
  props: {
    account: {
      type: Object
    },
  },
  data() {
    return {
      editorDialog: false,
    }
  },
  computed: {
  },
  created() {
    this.getArchivePackets(this.account.id)
  },
  methods: {
    refresh(){
      this.getUserPackets()
      this.$emit('refresh')
    },
    getUserPackets() {
      this.$refs.accountPackets.getUserPackets()
    },
  },
}
</script>

<template>
  <div>
    <v-expansion-panels dark  tile class="my-2" v-if="archiveSubscriptions.length">
      <v-expansion-panel>
        <v-expansion-panel-header class="font-weight-bold">{{$t('packet.archive')}} ({{archiveSubscriptions.length}})</v-expansion-panel-header>
        <v-expansion-panel-content>
          <subscriptions-simple-table :subscriptions="archiveSubscriptions" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <user-packets-list ref="accountPackets" @loadDone="(result) => activeSubscriptions = result" :account-id="account.id"/>
    <template v-if="!hasSubs">
      <v-alert dense dark text type="info">
        {{$t('packet.no_subscriptions_warn')}}
      </v-alert>
      <user-price-list @onBuy="refresh()" :account-id="account.id" />
    </template>
    <template v-if="hasSubs">
      <playlists v-if="hasSubs" :id="account.id" />
    </template>
  </div>
</template>

<style scoped>

</style>